import React, { useState } from 'react';
import { Button, Textarea, Modal } from '@ontruck/orc';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

const t = {
  title: 'Enter a reject reason please',
  reject: 'discard',
  cancel: 'cancel',
  rejectReason: ' Reject reason...',
};

const DocsRejectModal = ({ className, show, onClose, onSave, loading }) => {
  const [reason, setReason] = useState('');

  return (
    <Modal
      show={show}
      headerComponent={t.title}
      size="M"
      closeButton={false}
      onClose={onClose}
      onTop={true}
    >
      <div className={className}>
        <div className="docs-reject-modal">
          <Textarea
            id="delete_reason"
            name="delete_reason"
            label="delete_reason"
            className="docs-reject-modal__reject-field"
            onChange={(e, { value }) => setReason(value)}
            labelType="hidden"
            placeholder={t.rejectReason}
            height={'81px'}
          />
          <div className="docs-reject-modal__reject-actions">
            <Button onClick={() => onClose()} nude skin="secondary" size="M" text={t.cancel} />
            <Button
              onClick={() => {
                onSave(reason);
                setReason('');
                onClose();
              }}
              disabled={!reason || loading}
              skin="primary"
              size="M"
              text={t.reject}
              data-testid="docs-reject-modal__reject-button"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

DocsRejectModal.propTypes = {
  className: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default injectIntl(DocsRejectModal);
